import { render } from "./produceProgrammes.vue?vue&type=template&id=ff616df2&scoped=true"
import script from "./produceProgrammes.vue?vue&type=script&lang=js"
export * from "./produceProgrammes.vue?vue&type=script&lang=js"

import "./produceProgrammes.vue?vue&type=style&index=0&id=ff616df2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff616df2"]])

export default __exports__